<template>
  <div class="page">
    <div class = "header">
      <div class="d_c">
        <p>充值信息</p>
        <span class="rt-pos" @click="goBack()"></span>
      </div>
    </div>
    <div class="d_nei">
      <p>请选择支付方式：</p>
      <p v-if="renewCheckboxShow && userWx">
        <span>自动续费：</span>
        <nut-checkbox v-model="checkbox1" size="base" @change=checkboxChange()></nut-checkbox>
      </p>
      <p v-if="renewShow">
          <span class="renewalClass">
            {{ renewalDesc }}
          </span>
      </p>
      <div>
        <nut-radiogroup v-model="payType">
          <p v-if="wxDisabled">
              <span>
                <img src="../assets/img/paywx.svg" class="telecom-logo"/> 
                微信支付
              </span>
            <nut-radio label="1" size="base"></nut-radio>
          </p>
          <p v-if="userWx">
              <span>
                <img src="../assets/img/payzfb.svg" class="telecom-logo"/>      
                支付宝支付
              </span>
            <nut-radio label="2" size="base"></nut-radio>
          </p>
        </nut-radiogroup>
      </div>
    </div>
    <div class="footer">
      <nut-button @click="preOrder()">立即订购</nut-button>
    </div>
  </div>
</template>
<script>
import {wx_payOrder} from "@/api/api.js"; //h5支付
import {wx_queryOrder} from "@/api/api.js"; //检查订单是否支付
export default {
  data() {
    return {
      checkbox1: false,
      payType: "1",
      wxDisabled: true,
      renewShow: false,
      renewalDesc: "",
      renewCheckboxShow: false,
      userWx: true,
      renewalFlag: "",
      iccid: "",
      orderNum: "",
    };
  },
  watch:{
    $route: {
      handler() {
        if(this.$route.params.iccid){
          sessionStorage.setItem("preOrderParams.userWx", this.$route.params.userWx);
          sessionStorage.setItem("preOrderParams.renewalDesc", this.$route.params.renewalDesc);
          sessionStorage.setItem("preOrderParams.renewalFlag", this.$route.params.renewalFlag);
          sessionStorage.setItem("preOrderParams.iccid", this.$route.params.iccid);
          sessionStorage.setItem("preOrderParams.price", this.$route.params.price);
          sessionStorage.setItem("preOrderParams.productId", this.$route.params.productId);
          sessionStorage.setItem("preOrderParams.phone", this.$route.params.phone);
          sessionStorage.setItem("preOrderParams.verCode", this.$route.params.verCode);
          sessionStorage.setItem("preOrderParams.pid", this.$route.params.pid);
          sessionStorage.setItem("preOrderParams.type", this.$route.params.type);
          sessionStorage.setItem("preOrderParams.userId", this.$route.params.userId);
          sessionStorage.setItem("preOrderParams.channel", this.$route.params.channel);
          this.renewalDesc = this.$route.params.renewalDesc;
          this.renewalFlag = this.$route.params.renewalFlag;
          if (this.renewalFlag == 1) {
            this.renewCheckboxShow = true
          }
          this.userWx = this.$route.params.userWx;
          this.iccid = this.$route.params.iccid;
        } else {
          this.renewalDesc = sessionStorage.getItem("preOrderParams.renewalDesc");
          this.renewalFlag = sessionStorage.getItem("preOrderParams.renewalFlag");
          if (this.renewalFlag == 1) {
            this.renewCheckboxShow = true
          }
          this.userWx = sessionStorage.getItem("preOrderParams.userWx");
          this.iccid = sessionStorage.getItem("preOrderParams.iccid");
        }
      },
      immediate: true
    },
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack() {
      this.$router.go(-1);
    },
    // 自动续费勾选的逻辑处理
    checkboxChange() {
      if (this.checkbox1) {
        this.payType = "2";
        this.wxDisabled = false;
        this.renewShow = true;
      } else {
        this.payType = "1";
        this.wxDisabled = true;
        this.renewShow = false;
      }
    },
    // 生成订单
    preOrder() {
      let params = {
        iccid: sessionStorage.getItem("preOrderParams.iccid"),
        price: sessionStorage.getItem("preOrderParams.price"),
        productId: sessionStorage.getItem("preOrderParams.productId"),
        phone: sessionStorage.getItem("preOrderParams.phone"),
        verCode: sessionStorage.getItem("preOrderParams.verCode"),
        pid: sessionStorage.getItem("preOrderParams.pid"),
        type: sessionStorage.getItem("preOrderParams.type"),
        userId: sessionStorage.getItem("preOrderParams.userId"),
        channel: sessionStorage.getItem("preOrderParams.channel"),
        payType: this.payType,          // payType  1 微信 2 支付宝
        renewalFlag: this.checkbox1 == true ? "1" : "0"        // renewalFlag  套餐值 0不自动续费  1自动续费
      }
      wx_payOrder(params).then(res => {
        if (res.data.code == 200) {
          // payType 2-支付宝 3-支付宝自动续费 1-微信支付
          let that = this;
          if (res.data.data.payType == 2) {
            const div = document.createElement('formdiv');
            div.innerHTML = res.data.data.result;
            document.body.appendChild(div);
            document.forms[0].setAttribute('target', '_self');
            document.forms[0].submit();
            div.remove();
          } else if (res.data.data.payType == 3) {
            window.location.href = res.data.data.result;
            this.$dialog({
              title: "请在新打开的页面中完成支付",
              okBtnTxt: "已完成支付",
              onOkBtn(event) {
                this.close();
                wx_queryOrder({orderNum: res.data.data.orderNum}).then(res => {
                  console.log(res.data.data.orderStatus);
                  if (res.data.code == 200) {
                    if (res.data.data.orderStatus == "3") {
                      that.$router.push({
                        name: "info",
                        query: {
                          iccid: that.iccid
                        }
                      })
                    } else {
                      this.$toast.warn('订单支付失败系统将取消自动续费功能');
                    }
                  }
                })
              },
            });
          } else {
            // window.location.href = res.data.data.result;
            let form = document.createElement('form');
            document.body.appendChild(form);
            form.method = "post";
            form.action = res.data.data.result;
            form.submit();
            document.body.removeChild(form);
          }
        } else {
          this.$toast.fail(res.data.message);
        }
      })
    },
  },
  // beforeRouteLeave(to, form, next) {
  //   alert("离开了");
  //   next()
  // },
  created() {
  },
  mounted() {
    window.document.title = "确认订单";
  },
};
</script>
<style scoped lang="less">
.page {
  .header{
    text-align: center;
    height: 40px;
    line-height: 40px;
    background: #F94040;
    color: #fff;
    font-size: 18px;
  }
  .d_c {
    // text-align: center;
    // height: 40px;
    // line-height: 40px;
    // background: #F94040;
    // color: #fff;
    // font-size: 18px;
    // position: relative;

    .rt-pos {
      position: absolute;
      left: 20px;
      top: 14px;
      width: 12px;
      height: 12px;
      border-top: 2px solid gainsboro;
      border-left: 2px solid gainsboro;
      transform: rotate(-45deg);
    }
  }

  .d_nei {
    width: 95%;
    margin: 0 auto;
    padding: 5px;
    p {
      font-size: 14px;
      // padding: 8px;
      padding: 10px 8px;
      border-bottom: 1px solid #EDEDED;
      display: flex;
      justify-content: space-between;

      .p_c {
        color: #F94040;
      }
    }
  }

  .footer {
    background: #F8F8F8;
    padding: 15px 0;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 23;

    button {
      border-radius: 10px;
      width: 52%;
      font-size: 14px;
      height: 45px;
      line-height: 45px;
      border: 1px solid #F94040 !important;
    }
  }

  .telecom-logo {
    width: 25px;
    height: 25px;
  }

  .renewalClass {
    font-size: 12px;
    // text-align: center;
    text-indent: 5px;
  }

  /deep/ .nut-checkbox {
    margin-right: 0 !important;
    // position: relative;
    top: -2px;
    width: 35px;
    text-align: right;
  }

  /deep/ .nut-radio {
    margin-right: 0 !important;
    width: 35px;
    text-align: right;
  }

  /deep/ .nut-textinput-clear {
    display: none;
  }
}
</style>


